// Constants
import {
    TIMESHEET_ENTRIES_LOAD_REQUESTED,
    TIMESHEET_ENTRIES_LOAD_SUCCEEDED,
    TIMESHEET_ENTRIES_LOAD_FAILED,
    TIMESHEET_ENTRIES_LOAD_CANCELED,
    TIMESHEET_ENTRY_UPDATE_REQUESTED,
    TIMESHEET_ENTRY_UPDATE_SUCCEEDED,
    TIMESHEET_ENTRY_UPDATE_FAILED,
    TIMESHEET_ENTRIES_APPROVE_REQUESTED,
    TIMESHEET_ENTRIES_APPROVE_SUCCEEDED,
    TIMESHEET_ENTRIES_APPROVE_FAILED,
    TIMESHEET_ENTRIES_DELETE_REQUESTED,
    TIMESHEET_ENTRIES_DELETE_SUCCEEDED,
    TIMESHEET_ENTRIES_DELETE_FAILED,
    TIMESHEET_ENTRIES_SET
} from './constants';
import {
    TimesheetEntry,
    RequestLoadTimesheetEntriesAction,
    SucceededLoadTimesheetEntriesAction,
    FailedLoadTimesheetEntriesAction,
    CanceledLoadTimesheetEntriesAction,
    RequestUpdateTimesheetEntryAction,
    SucceededUpdateTimesheetEntryAction,
    FailedUpdateTimesheetEntryAction,
    RequestApproveTimesheetEntriesAction,
    SucceededApproveTimesheetEntriesAction,
    FailedApproveTimesheetEntriesAction,
    RequestDeleteTimesheetEntriesAction,
    SucceededDeleteTimesheetEntriesAction,
    FailedDeleteTimesheetEntriesAction,
    SetTimesheetEntriesAction
} from './types';

export function requestLoadTimesheetEntries(): RequestLoadTimesheetEntriesAction {
    return {
        type: TIMESHEET_ENTRIES_LOAD_REQUESTED
    };
}

export function succeededLoadTimesheetEntries(
    response: Record<string, any>
): SucceededLoadTimesheetEntriesAction {
    return {
        type: TIMESHEET_ENTRIES_LOAD_SUCCEEDED,
        payload: response
    };
}

export function failedLoadTimesheetEntries(
    error: Error
): FailedLoadTimesheetEntriesAction {
    return {
        type: TIMESHEET_ENTRIES_LOAD_FAILED,
        payload: error,
        error: true
    };
}

export function canceledLoadTimesheetEntries(): CanceledLoadTimesheetEntriesAction {
    return {
        type: TIMESHEET_ENTRIES_LOAD_CANCELED
    };
}

export function requestUpdateTimesheetEntry(
    timesheetEntryUuid: number,
    data: TimesheetEntry
): RequestUpdateTimesheetEntryAction {
    return {
        type: TIMESHEET_ENTRY_UPDATE_REQUESTED,
        payload: {
            timesheetEntryUuid,
            data
        }
    };
}

export function succeededUpdateTimesheetEntry(
    response: Record<string, any>
): SucceededUpdateTimesheetEntryAction {
    return {
        type: TIMESHEET_ENTRY_UPDATE_SUCCEEDED,
        payload: response
    };
}

export function failedUpdateTimesheetEntry(
    error: Error
): FailedUpdateTimesheetEntryAction {
    return {
        type: TIMESHEET_ENTRY_UPDATE_FAILED,
        payload: error,
        error: true
    };
}

export function requestApproveTimesheetEntries(
    timesheetEntryUuids: Array<number>
): RequestApproveTimesheetEntriesAction {
    return {
        type: TIMESHEET_ENTRIES_APPROVE_REQUESTED,
        payload: {
            timesheetEntryUuids
        }
    };
}

export function succeededApproveTimesheetEntries(
    response: Record<string, any>
): SucceededApproveTimesheetEntriesAction {
    return {
        type: TIMESHEET_ENTRIES_APPROVE_SUCCEEDED,
        payload: response
    };
}

export function failedApproveTimesheetEntries(
    error: Error
): FailedApproveTimesheetEntriesAction {
    return {
        type: TIMESHEET_ENTRIES_APPROVE_FAILED,
        payload: error,
        error: true
    };
}

export function requestDeleteTimesheetEntries(
    timesheetEntryUuids: Array<number>
): RequestDeleteTimesheetEntriesAction {
    return {
        type: TIMESHEET_ENTRIES_DELETE_REQUESTED,
        payload: {
            timesheetEntryUuids
        }
    };
}

export function succeededDeleteTimesheetEntries(
    responses: Array<Record<string, any>>
): SucceededDeleteTimesheetEntriesAction {
    return {
        type: TIMESHEET_ENTRIES_DELETE_SUCCEEDED,
        payload: responses
    };
}

export function failedDeleteTimesheetEntries(
    error: Error
): FailedDeleteTimesheetEntriesAction {
    return {
        type: TIMESHEET_ENTRIES_DELETE_FAILED,
        payload: error,
        error: true
    };
}

export function setTimesheetEntries(
    data: Record<string, TimesheetEntry>
): SetTimesheetEntriesAction {
    return {
        type: TIMESHEET_ENTRIES_SET,
        payload: data
    };
}
